<template>
  <div class="forgotPassword studies_bg">
    <div class="container container-style">
      <div class="row">
        <div class="col-xs-12 col-md-12 col-lg-12 col-sm-12" v-if="message">
          <p class="fs-24 text-center color_ff">{{ message }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import localStorageService from "@/services/localStorage";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "unsubscribeemailPage",
  data() {
    return {
      participantId: null,
      message: null
    };
  },
  computed: {
    ...mapGetters(["participantId"]),
    participantVal() {
      return this.participantId;
    }
  },
  watch: {
    participantVal: {
      handler(val) {
        if (val) {
          this.unsubscribeParticipant();
        }
      }
    }
  },
  methods: {
    ...mapActions(["userLogout"]),
    unsubscribeParticipant() {
      nprogress.start();
      if (Vue.http) {
        Vue.http.headers.common.clientId = localStorageService.getItem("clientId");
      }
      this.$api.batchUnsubscribeResource(this.participantId).then(
        response => {
          nprogress.done();
          this.message = response.body.message;
        },
        error => {
          nprogress.done();
          this.message = error.body.message;
        }
      );
    }
  },
  mounted() {
    this.participantId = this.$route.params.participantId;
    this.unsubscribeParticipant();
  }
};
</script>

<style lang="scss">
.studies_bg {
  background: url("/static/img/bg/login_bg.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
  min-height: 100vh;
  /*color: #fff;*/
  background-color: #34537d;
  background-blend-mode: soft-light;
}
h1,
h2 {
  font-weight: normal;
  color: #00baf9;
}

.font-style {
  margin-bottom: 15px;
  margin-top: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #00baf9;
}

.link-style {
  font-size: 16px;
  text-align: center;
}

.p-style {
  color: #8c8c8c;
  font-size: 14px;
  padding-bottom: 30px;
}

.panel-padding {
  padding: 15px 15px 28px 15px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
}

.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}
.container-style {
  padding-top: 120px;
}

@media (max-width: 1023px) {
  body {
    width: auto;
    min-width: auto;
  }
}
</style>
